module.exports = __webpack_public_path__ + "static/media/share.29c841e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share.png
// module id = 181
// module chunks = 0